import { Divider, SubSectionHeader } from "./styled";

export const SetupSection = ({
  title,
  children,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className="w-full mb-10 flex flex-col gap-4 text-sm leading-tight">
    <Divider />
    <SubSectionHeader>{title}</SubSectionHeader>
    {children}
  </div>
);
